import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Button from 'material-ui/Button';
import Typography from 'material-ui/Typography';
import DialogModal from '../../common/DialogModal';

const styles = () => ({
  paper: {
    maxHeight: "unset",
    background: "#F4F6F9",
    width: "600px",
  },

  contentContainer: {
    margin: '0px',
    padding: '30px 25px 25px',
    width: '100%',
    boxSizing: 'border-box',
  },

  button: {
    width: "100%",
    background: "#1A65FF",
    marginTop: "30px",
  },

  buttonDelete: {
    background: "#F03A47",
    width: "100%",
    marginTop: "30px",
  },
});

class ChildAccountConfirmDialog extends React.Component {
  handleClick = () => {
    const { childUser } = this.props;
    this.props.func(childUser.id);
    this.props.toggleDialog();
  }

  render() {
    const { classes, isOpen, toggleDialog, title, type, isProcessing } = this.props;
    let confirmText = 'このアカウントを削除しても、履歴はオーナーアカウントから消えることはありません。'
    let buttonText = 'アカウントを削除'
    if (type && type === 'proxy_login') {
      confirmText = 'このアカウントとしてログインしますか？右上のメニューからいつでもオーナーアカウントに切り替えることができます。'
      buttonText = '代理ログイン'
    }
    return (
      <DialogModal
        classes={{
          paper: classes.paper,
          contentContainer: classes.contentContainer,
        }}
        open={isOpen}
        aria-labelledby="pop-up-window"
        maxWidth={false}
        onClose={toggleDialog}
        title={title}
      >
        <Typography align="left" style={{ fontSize: '13px' }}>
          {confirmText}
        </Typography>

        <Button
          color={type === 'delete' ? "secondary" : "primary"}
          className={type === 'delete' ? classes.buttonDelete : classes.button}
          variant="raised"
          onClick={this.handleClick}
          fullWidth
          disabled={isProcessing}
          style={{ boxShadow: 'none' }}
        >
          {buttonText}
        </Button>
      </DialogModal>
    );
  }
}

ChildAccountConfirmDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  func: PropTypes.func,
  type: PropTypes.string,
  childUser: PropTypes.object,
  title: PropTypes.string,
  isProcessing: PropTypes.bool,
};

export default withStyles(styles)(ChildAccountConfirmDialog);



// WEBPACK FOOTER //
// ./src/components/AccountSetting/dialogs/ChildAccountConfirmDialog.jsx